import React, { Component } from 'react';
import * as styled from '../../../styles/style';
import arrow from '../../../images/arrow.svg';

class Accordion extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, admin, disabled, children, id } = this.props;
    const open = !this.props.closed && !disabled;

    return (
      <styled.Accordion disabled={disabled} id={id}>
        <styled.AccordionH1 className={admin ? 'admin' : ''} onClick={(e) => !disabled && this.props.update && this.props.update(e, id)}>
          <div className="title">{title}</div>
          <img style={{transform: (open && !disabled ? '' : 'rotate(90deg)')}} src={arrow} />
        </styled.AccordionH1>
        {open && children}
      </styled.Accordion>
    )
  }
}

export default Accordion;
